import { DiscountCodeResponseType } from "../store/Booking";
import { ICharge } from "./ICharge";
import { IDiscountCode } from "./IDiscountCode";

export interface IInvoice {
    invoiceId: number;
    siteId: number;
    paymentStatusTypeId: PaymentStatusType;
    charge: ICharge;
    discountCodes: IDiscountCode[];
    applyDiscountResponseType?: DiscountCodeResponseType;
}

export interface ICreateInvoiceRequest {
    buyerPlayerGuid: string;
    paymentMethodTypeId: number;
    digitalAddOns: IBookingDigitalAddOnRequest[];
}

export interface IConfirmInvoiceRequest {
    emailAddress: string;
    fullName: string | undefined;
    amount: number;
    currencyCode: string;
    dateCreated: string;
    paymentMethodReference: string;
    paymentMethodTypeId: number;
    siteId: number;
    tax: number;
}

export interface IUpdateInvoiceRequest {
    paymentMethodTypeId: number;
    digitalAddOns: IBookingDigitalAddOnRequest[];
}

export interface IBookingDigitalAddOnRequest {
    bookingId: number;
    digitalAddOnOptionId: number;
    quantity: number;
    playerGuids: string[];
}

export enum PaymentStatusType {
    AwaitingPayment = 1,
    Approved = 2,
    Cancelled = 3,
    Refunded = 4,
    Failed = 5,
    Expired = 6,
    Completed = 7
}